// extracted by mini-css-extract-plugin
module.exports = {"container":"links-section_container__u0v5l","sectionTitle":"links-section_sectionTitle__Rmek0"};